import React from 'react';
import { Lock } from 'lucide-react';

interface RestrictedStateProps {
  title?: string;
  description?: string;
  variant?: 'ownersOnly' | 'blocked' | 'removed' | 'locked';
}

export default function RestrictedState({
  title,
  description,
  variant = 'ownersOnly',
}: RestrictedStateProps) {
  const configs = {
    ownersOnly: {
      defaultTitle: 'Owners Only',
      defaultDesc: 'This content is visible to verified unit owners only. Ownership verification is required to access this section.',
      color: '#4CC9FF',
      bg: 'rgba(76,201,255,0.06)',
      border: 'rgba(76,201,255,0.15)',
    },
    blocked: {
      defaultTitle: 'Content Unavailable',
      defaultDesc: 'This profile is not available to you.',
      color: '#A7A3C4',
      bg: 'rgba(167,163,196,0.06)',
      border: 'rgba(167,163,196,0.15)',
    },
    removed: {
      defaultTitle: 'Content Removed',
      defaultDesc: 'This content has been removed and is no longer available.',
      color: '#FF6B6B',
      bg: 'rgba(192,57,43,0.06)',
      border: 'rgba(192,57,43,0.15)',
    },
    locked: {
      defaultTitle: 'Thread Locked',
      defaultDesc: 'This thread has been locked and no longer accepts new replies.',
      color: '#F0A832',
      bg: 'rgba(185,123,26,0.06)',
      border: 'rgba(185,123,26,0.15)',
    },
  };

  const config = configs[variant];

  return (
    <div
      className="flex flex-col items-center justify-center py-16 px-6 text-center rounded-xl"
      style={{ background: config.bg, border: `1px solid ${config.border}` }}
    >
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
        style={{ background: `${config.bg}`, border: `1px solid ${config.border}` }}
      >
        <Lock size={20} style={{ color: config.color }} />
      </div>
      <h3 className="font-display font-semibold text-[17px] mb-2" style={{ color: config.color }}>
        {title ?? config.defaultTitle}
      </h3>
      <p className="text-[13.5px] leading-relaxed max-w-sm" style={{ color: '#A7A3C4' }}>
        {description ?? config.defaultDesc}
      </p>
    </div>
  );
}
